import React, { FC } from "react";
import classNames from "classnames";
import { Select, SelectProps } from "antd";

import { BemHelper } from "../../utils";

const bem = new BemHelper("select-c");

export type Props = SelectProps & { label?: string };

export const SelectC: FC<Props> = ({ children, style, ...props }) => {
  return (
    <div className={classNames([bem.block()])}>
      {props.label && <label>{props.label}</label>}
      <Select {...props} style={{ ...style, marginTop: props.label ? "10px" : "0px" }}>
        {children}
      </Select>
    </div>
  );
};
